/**
  * vue-cal v3.11.0
  * (c) 2022 Antoni Andre <antoniandre.web@gmail.com>
  * @license MIT
  */
const e = ["Pond\u011Bl\xED", "\xDAter\xFD", "St\u0159eda", "\u010Ctvrtek", "P\xE1tek", "Sobota", "Ned\u011Ble"], t = ["Leden", "\xDAnor", "B\u0159ezen", "Duben", "Kv\u011Bten", "\u010Cerven", "\u010Cervenec", "Srpen", "Z\xE1\u0159\xED", "\u0158\xEDjen", "Listopad", "Prosinec"], a = "Roky", n = "Rok", s = "M\u011Bs\xEDc", d = "T\xFDden", o = "Den", r = "Dnes", y = "Bez ud\xE1lost\xED", l = "Cel\xFD den", v = "Odstranit", D = "Vytvo\u0159it ud\xE1lost", k = "dddd D. MMMM YYYY", M = { weekDays: e, months: t, years: "Roky", year: "Rok", month: "M\u011Bs\xEDc", week: "T\xFDden", day: "Den", today: "Dnes", noEvent: "Bez ud\xE1lost\xED", allDay: "Cel\xFD den", deleteEvent: "Odstranit", createEvent: "Vytvo\u0159it ud\xE1lost", dateFormat: "dddd D. MMMM YYYY" };
export {
  l as allDay,
  D as createEvent,
  k as dateFormat,
  o as day,
  M as default,
  v as deleteEvent,
  s as month,
  t as months,
  y as noEvent,
  r as today,
  d as week,
  e as weekDays,
  n as year,
  a as years
};
